const emptyCallback = () => undefined;
export default class ExternalCallbackStore {
    constructor(externalCallbacks) {
        Object.defineProperty(this, "onPathChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onLangChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onClientStateChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onHeaderSectionChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "onHeaderSegmentChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "initialCallbacks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (props) => {
                this.onPathChange = props.onPathChange || emptyCallback;
                this.onLangChange = props.onLangChange || emptyCallback;
                this.onClientStateChange = props.onClientStateChange || emptyCallback;
                this.onHeaderSectionChange = props.onSectionChange || emptyCallback;
                this.onHeaderSegmentChange = props.onSegmentChange;
            }
        });
        this.initialCallbacks(externalCallbacks);
    }
}
//# sourceMappingURL=ExternalCallbackStore.js.map